// Ticks "Ich interessiere mich für Pächtersuche Pro" on the "Objekt anbieten"
// form when the visitor gets there from one of the two Pächtersuche Pro
// buttons: the plan card's "Pro anfragen" and the green band's "Beratung zu
// Pächtersuche Pro".
//
//     <a href="#anbieten" data-re-pachtpro>Pro anfragen</a>
//
// The link is an ordinary jump to the form, so this only adds the tick. It
// never unticks: a visitor who ticked the box themselves and then clicked
// "Plus anfragen" has still said they are interested. No-op once the form has
// been sent, when the confirmation replaces it and the box is gone.

const TRIGGER_SELECTOR = "[data-re-pachtpro]";
const CHECKBOX_SELECTOR = '#submit_offer_form input[name="wants_pachtpro"]';

document.addEventListener("click", (event) => {
    if (!event.target.closest(TRIGGER_SELECTOR)) {
        return;
    }
    const checkbox = document.querySelector(CHECKBOX_SELECTOR);
    if (checkbox) {
        checkbox.checked = true;
    }
});
